import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}
// eslint-disable-next-line id-length
export const Row = (props: Props) => {
  const { children, className } = props;
  return <tr className={className}>{children}</tr>;
};
